exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.widgets {\n  margin: 10px 0 20px !important;\n}\n.wrapper-widget {\n  position: relative;\n  border: 1px solid #fafafa;\n  background: #526da5;\n  padding: 10px !important;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n.wrapper-widget.disabled {\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n.wrapper-widget p.title-widget {\n}\n.wrapper-widget p.count {\n  bottom: 0;\n  position: absolute;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n.flex.md1 {\n  max-width: none;\n}\n", ""]);

// exports
